'use client'

import { useEffect, useState } from 'react'
import { mockDb } from '@/mock/db'

export default function MockDataInitializer({ children }: { children: React.ReactNode }) {
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    mockDb.init(500).then(() => {
      setInitialized(true)
    })
  }, [])

  if (!initialized) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="text-2xl font-bold text-primary mb-2">
            <span className="text-brand-green">Evaly</span>
            <span className="text-brand-orange">Lite</span>
          </div>
          <div className="text-sm text-muted-foreground">Loading products...</div>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
